import { CDK_REDIRECT_URL } from 'app/App';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useLogoutUser } from 'lib/api/users/useLogoutUser';
import { WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { useAuth } from 'lib/context';
import { useEffect } from 'react';
import { useCDK } from './useCdk';

export const useGlobalAxiosErrorHandler = () => {
  const { whitelabel } = useAuth();
  const { isCdkUser } = useCDK();
  const { mutateAsync: logoutUser } = useLogoutUser();

  useEffect(() => {
    const redirectParam =
      whitelabel?.name === WHITELABEL_NAME.COVIDEO
        ? `${window.location.toString()}`
        : '';

    const responseInterceptor = EXPRESS_API.interceptors.response.use(
      res => res,
      err => {
        const status = err.response?.status;
        if (status === 401 && isCdkUser) {
          window.location.href = CDK_REDIRECT_URL;
          return;
        }
        if (status === 401) {
          logoutUser({ redirect: redirectParam });
        }

        return Promise.reject(err);
      }
    );

    return () => {
      EXPRESS_API.interceptors.response.eject(responseInterceptor);
    };
  }, [whitelabel]);
};
